import React from "react";
import PropTypes from "prop-types";
import Select from "react-dropdown-select";
import styles from "./form-generator.module.scss";

const SelectInput = ({
  field,
  formikprops,
  dropdownPosition,
  isAreaOfFocusField,
}) => {
  const {
    id,
    section_name: label,
    placeholder,
    section_option_values: optionValues,
    multiselect: allowMultiselect,
  } = field;

  const { setFieldValue, errors, touched } = formikprops;
  const isInvalid = errors[id] && touched[id];

  const formattedOptions = isAreaOfFocusField
    ? optionValues
    : optionValues.map((option) => ({
      label: option,
      value: option,
    }));

  const handleChange = (values) => {
    if (isAreaOfFocusField) {
      setFieldValue(
        id,
        values.map((item) => item.id),
      );
      return;
    }
    setFieldValue(
      id,
      values.map(({ value }) => value),
    );
  };

  return (
    <div className={styles.formGroup} key={`field-${id}`}>
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
      {isAreaOfFocusField ? (
        <Select
          id={id}
          name={id}
          valueField="id"
          labelField="name"
          multi={allowMultiselect}
          options={formattedOptions}
          onChange={handleChange}
          values={[]}
          placeholder={placeholder}
          dropdownPosition={dropdownPosition || "auto"}
        />
      ) : (
        <Select
          id={id}
          name={id}
          multi={allowMultiselect}
          options={formattedOptions}
          onChange={handleChange}
          values={[]}
          placeholder={placeholder}
          dropdownPosition={dropdownPosition || "auto"}
        />
      )}
      {isInvalid && <div className={styles.invalidFeedback}>{errors[id]}</div>}
    </div>
  );
};

SelectInput.defaultProps = {
  dropdownPosition: "auto",
  isAreaOfFocusField: false,
};

SelectInput.propTypes = {
  dropdownPosition: PropTypes.string,
  field: PropTypes.shape({
    id: PropTypes.string.isRequired,
    multiselect: PropTypes.bool.isRequired,
    section_name: PropTypes.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    section_option_values: PropTypes.arrayOf(PropTypes.any).isRequired,
    placeholder: PropTypes.string,
  }).isRequired,
  formikprops: PropTypes.shape({
    setFieldValue: PropTypes.func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    values: PropTypes.objectOf(PropTypes.any).isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    errors: PropTypes.objectOf(PropTypes.any).isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    touched: PropTypes.objectOf(PropTypes.any).isRequired,
  }).isRequired,
  isAreaOfFocusField: PropTypes.bool,
};

export default SelectInput;
